export default __webpack_public_path__ + "static/media/Ronnie_Feng_mobile_portfolioHigh_quality.dbf6b2ca.webp";